import { Module, ModuleVariantsType } from '../../types'

export const createNonCardMultipleVariantsConfiguration = (): Module[] => {
  return [
    {
      __typename: 'ModuleTwoColumn',
      left: [{ __typename: 'ModuleImages' }],
      right: [
        { __typename: 'ModuleTitle' },
        { __typename: 'ModulePills' },
        { __typename: 'ModuleRating' },
        { __typename: 'ModuleFromPrice' },
        { __typename: 'ModuleUSPList' },
        { __typename: 'ModuleKlarnaInfo' },
        { __typename: 'ModuleDispatch' },
        { __typename: 'ModuleUpsell' },
        { __typename: 'ModuleVariants', type: ModuleVariantsType.RADIO },
        { __typename: 'ModuleAddons' },
        { __typename: 'ModuleQuantity' },
        { __typename: 'ModuleButtons' },
        { __typename: 'ModuleMoreInfo' },
      ],
      ratio: '50/50',
    },
  ]
}
